import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaFabricante from './Components/TabelaFabricanteVeiculo'


const mockPermissions = [
  { id: 1, fabricanteveiculo: 'Toyota', ativo: true },
  { id: 2, fabricanteveiculo: 'Volkswagen', ativo: true },
  { id: 3, fabricanteveiculo: 'Ford', ativo: true },
  { id: 4, fabricanteveiculo: 'Chevrolet', ativo: false },
  { id: 5, fabricanteveiculo: 'Honda', ativo: true },
  { id: 6, fabricanteveiculo: 'Nissan', ativo: false },
  { id: 7, fabricanteveiculo: 'Hyundai', ativo: true },
  { id: 8, fabricanteveiculo: 'BMW', ativo: true },
  { id: 9, fabricanteveiculo: 'Mercedes-Benz', ativo: false },
  { id: 10, fabricanteveiculo: 'Audi', ativo: true },
];



function Fabricante() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox',isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Fabricante do Veículo', key: 'fabricanteveiculo', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Fabricante do Veículo'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaFabricante headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default Fabricante